import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });
export default client;

// Projects (public)
export const getProjects = (params = {}) => client.get('/projects', { params }).then((r) => r.data);
export const getProject = (id) => client.get(`/projects/${id}`).then((r) => r.data);

// Inquiries (public)
export const createInquiry = (data) => client.post('/inquiries', data).then((r) => r.data);

// Auth
export const createSession = (session_id) => client.post('/auth/session', { session_id }).then((r) => r.data);
export const getMe = () => client.get('/auth/me').then((r) => r.data);
export const logout = () => client.post('/auth/logout').then((r) => r.data);

// Investor
export const getSaved = () => client.get('/me/saved').then((r) => r.data);
export const addSaved = (id) => client.post(`/me/saved/${id}`).then((r) => r.data);
export const removeSaved = (id) => client.delete(`/me/saved/${id}`).then((r) => r.data);
export const getPortfolio = () => client.get('/me/portfolio').then((r) => r.data);

// Admin
export const adminCreateProject = (data) => client.post('/admin/projects', data).then((r) => r.data);
export const adminUpdateProject = (id, data) => client.put(`/admin/projects/${id}`, data).then((r) => r.data);
export const adminDeleteProject = (id) => client.delete(`/admin/projects/${id}`).then((r) => r.data);
export const adminGetInquiries = () => client.get('/admin/inquiries').then((r) => r.data);

// Investor: holdings & marketplace
export const getMyHoldings = () => client.get('/me/holdings').then((r) => r.data);
export const getHoldingDetail = (id) => client.get(`/me/holdings/${id}`).then((r) => r.data);
export const getNotifications = () => client.get('/me/notifications').then((r) => r.data);
export const markNotificationsRead = () => client.post('/me/notifications/read').then((r) => r.data);
export const statementUrl = () => `${API}/me/statement.pdf`;
export const adminBulkValuations = (rows) => client.post('/admin/holdings/valuations', { rows }).then((r) => r.data);
export const adminImportHistory = (rows) => client.post('/admin/holdings/history', { rows }).then((r) => r.data);
export const adminApproveKyc = (userId) => client.post(`/admin/investors/${userId}/kyc-approve`).then((r) => r.data);
// KYC (investor)
export const getKyc = () => client.get('/me/kyc').then((r) => r.data);
export const submitKyc = (data) => client.post('/me/kyc', data).then((r) => r.data);
// Investor overview deck (public PDF)
export const deckUrl = () => `${API}/investor-overview.pdf`;
export const getListings = () => client.get('/marketplace/listings').then((r) => r.data);
export const getMyMarket = () => client.get('/marketplace/my').then((r) => r.data);
export const createListing = (data) => client.post('/marketplace/listings', data).then((r) => r.data);
export const cancelListing = (id) => client.delete(`/marketplace/listings/${id}`).then((r) => r.data);
export const placeBid = (id, amount) => client.post(`/marketplace/listings/${id}/bids`, { amount }).then((r) => r.data);
export const acceptBid = (id, bidId) => client.post(`/marketplace/listings/${id}/accept`, { bidId }).then((r) => r.data);

// Admin: investors
export const adminGetInvestors = () => client.get('/admin/investors').then((r) => r.data);
export const adminGetInvestorDetail = (userId) => client.get(`/admin/investors/${userId}`).then((r) => r.data);
export const adminAddInvestor = (data) => client.post('/admin/investors', data).then((r) => r.data);
export const adminUpdateInvestor = (userId, data) => client.put(`/admin/investors/${userId}`, data).then((r) => r.data);
export const adminSuspendInvestor = (userId) => client.post(`/admin/investors/${userId}/suspend`).then((r) => r.data);
export const adminReactivateInvestor = (userId) => client.post(`/admin/investors/${userId}/reactivate`).then((r) => r.data);
export const adminRejectKyc = (userId, reason) => client.post(`/admin/investors/${userId}/kyc-reject`, { reason }).then((r) => r.data);
export const adminRemoveInvestor = (userId) => client.delete(`/admin/investors/${userId}`).then((r) => r.data);
// Admin: holdings
export const adminGetHoldings = () => client.get('/admin/holdings').then((r) => r.data);
export const adminAddHolding = (data) => client.post('/admin/holdings', data).then((r) => r.data);
export const adminBulkHoldings = (rows) => client.post('/admin/holdings/bulk', { rows }).then((r) => r.data);
export const adminUpdateHolding = (id, data) => client.put(`/admin/holdings/${id}`, data).then((r) => r.data);
export const adminDeleteHolding = (id) => client.delete(`/admin/holdings/${id}`).then((r) => r.data);
// Admin: marketplace
export const adminGetListings = () => client.get('/admin/marketplace/listings').then((r) => r.data);
export const adminSettleListing = (id) => client.post(`/admin/marketplace/${id}/settle`).then((r) => r.data);

// Documents & certificates
export const certificateUrl = (holdingId) => `${API}/me/holdings/${holdingId}/certificate.pdf`;
export const getHoldingDocuments = (holdingId) => client.get(`/me/holdings/${holdingId}/documents`).then((r) => r.data);
export const downloadDocumentBlob = (docId) => client.get(`/documents/${docId}/download`, { responseType: 'blob' }).then((r) => r.data);
export const uploadKycDocument = (file) => { const fd = new FormData(); fd.append('file', file); return client.post('/me/kyc/document', fd).then((r) => r.data); };
export const adminKycDocumentBlob = (userId) => client.get(`/admin/investors/${userId}/kyc-document`, { responseType: 'blob' }).then((r) => r.data);
export const adminGetHoldingDocuments = (holdingId) => client.get(`/admin/holdings/${holdingId}/documents`).then((r) => r.data);
export const adminUploadHoldingDocument = (holdingId, file, title) => { const fd = new FormData(); fd.append('file', file); fd.append('title', title || ''); return client.post(`/admin/holdings/${holdingId}/documents`, fd).then((r) => r.data); };
export const adminDeleteDocument = (docId) => client.delete(`/admin/documents/${docId}`).then((r) => r.data);
// Admin: statements
export const adminSendStatementsNow = () => client.post('/admin/statements/send-now').then((r) => r.data);
export const adminTestStatement = (data) => client.post('/admin/statements/test-send', data || {}).then((r) => r.data);
// Admin: demo data
export const adminSeedDemo = () => client.post('/admin/seed-demo').then((r) => r.data);
// Admin: audit trail
export const adminGetAudit = () => client.get('/admin/audit').then((r) => r.data);
// Investor reports (archived statements)
export const getReports = () => client.get('/me/reports').then((r) => r.data);
export const downloadReportBlob = (id) => client.get(`/me/reports/${id}/download`, { responseType: 'blob' }).then((r) => r.data);
